import { render, staticRenderFns } from "./_ConsentLayout.vue?vue&type=template&id=513d4b23&scoped=true&"
import script from "./_ConsentLayout.vue?vue&type=script&lang=ts&"
export * from "./_ConsentLayout.vue?vue&type=script&lang=ts&"
import style0 from "./_ConsentLayout.vue?vue&type=style&index=0&id=513d4b23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d4b23",
  null
  
)

export default component.exports